export default "__VITE_ASSET__DZlpXZQF__"